import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'
import index from '@/pages/index'

import home from '@/pages/home'

import PageContent from '@/components/PageContent'
import ChildRegister from '@/pages/child/register'
import ChildManage from '@/pages/child/manage'
import CureOutlayPage from '@/pages/outlay/cure'
import CheckOutlayPage from '@/pages/outlay/check'
import ProtocolManageTab from '@/pages/protocol/manage'
import ProtocolDetail from '@/pages/protocol/manage/ProtocolDetail'
import ProtocolAuditDetail from '@/pages/protocol/manage/ProtocolAuditDetail'
import RefundInfo from '@/pages/protocol/refund/RefundInfo'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name: 'index',
    component: index,
    children: [
      { path: '/home',name:'首页', component: home },
      { path: '/child/detail',name:'患儿详情', meta: { path: '/child/manage', unKeepAlive: true }, component: () => { return import('@/pages/child/view/ChildDetail') } },
      { path: '/child/childShDetail',name:'患儿审核详情', meta: { path: '/child/audit', unKeepAlive: true }, component: () => { return import('@/pages/child/audit/childShDetail') } },
      { path: '/child/hospital',name:'患儿代申请', component: () => { return import('@/pages/child/hospital') } },
      { path: '/child/hospital/add',name:'患儿代申请新增', meta: { path: '/child/hospital', unKeepAlive: true }, component: () => { return import('@/pages/child/hospital/HospitalChildInfo') } },
      { path: '/child/register',name:'患儿注册', meta: { unKeepAlive: true }, component: ChildRegister },
      { path: '/child/manage',name:'患儿管理', component: ChildManage },
      { path: '/child/refund/:protocolId/:applyType/:applyId?/:readOnly?/:upload?', name:'退款协议', meta: { path: '/child/manage', unKeepAlive: true }, component: () => { return import('@/pages/protocol/view/ProtocolDetailPage') } },
      { path: '/child/supplement/:protocolId/:applyType/:applyId?/:readOnly?', name:'补款协议', meta: { path: '/child/manage', unKeepAlive: true }, component: () => { return import('@/pages/protocol/view/ProtocolDetailPage') } },
      { path: '/child/audit',name:'患儿审核', component: () => { return import('@/pages/child/audit') } },
      { path: '/outlay/cure',name:'治疗费用填报', component: CureOutlayPage },
      { path: '/outlay/check',name:'检查费用填报', component: CheckOutlayPage },
      { path: '/protocol/manage',name:'协议管理', component: ProtocolManageTab },
      { path: '/protocol/detail/:id',name:'协议详情', meta: { path: '/protocol/manage', unKeepAlive: true }, component: ProtocolDetail },
      { path: '/protocol/detail/audit/:id',name:'协议详情', meta: { path: '/protocol/manage', unKeepAlive: true }, component: ProtocolAuditDetail },
      { path: '/protocol/refund/:protocolId/:applyType/:applyId?/:readOnly?/:upload?', name:'退款协议申请',meta: { path: '/protocol/manage', unKeepAlive: true }, component: () => { return import('@/pages/protocol/view/ProtocolDetailPage') } },
      { path: '/protocol/supplement/:protocolId/:applyType/:applyId?/:readOnly?', name:'补款协议申请',meta: { path: '/protocol/manage', unKeepAlive: true }, component: () => { return import('@/pages/protocol/view/ProtocolDetailPage') } },
    ], // '/users'路由既显示Home组件又显示Users子组件
    redirect: '/home' // 通过重定向当访问'/'时自动跳转到包含Users组件的页面
  },
  {
    path: '/login',
    name: 'login',
    component: login
  }
]



const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
const router = createRouter()
export default router



// WEBPACK FOOTER //
// ./src/router/index.js